import React, { useState, useEffect, useRef } from "react";
import logo from "../../assets/Form/logoc.png";
import tylogo from "../../assets/Form/DesktopLogo.png";
import successIcon from "../../assets/Form/success.png";
import tyBuildings from "../../assets/Form/tybuildings.png";
import tyBuildingsMobile from "../../assets/Form/tybuildingsmobile.png";
import bgC from "../../assets/Form/bgride.png";
import womanLawyerC from "../../assets/Form/womanlawyerc.png";
import symptomsarentsmall from "../../assets/Form/symptomsarentsmall.png";
import dollarbag from "../../assets/Form/dollarbag.png";
import statistics from "../../assets/Form/statistics.png";
import faqArrow from "../../assets/Form/faqarrow.svg";
import faqArrowD from "../../assets/Form/faqarrowdown.svg";
import rideC from "../../assets/Form/ridesharec.png";
import rideCM from "../../assets/Form/ridesharecm.png";

import { RideshareSALawsuitSendAdminEmail, RideshareSALawsuitSendUserEmail } from '../../emailService';
import {
  buildAdvancedMatching,
  ensureMetaPixel,
  normalizeEmail,
  normalizePhone,
  isValidEmail,
  isValidPhoneDigits,
  trackEventWithUserData
} from '../../utils/metaPixel';
import { LeadVertical } from "../../utils/common";

/**
 * DepoProveraLawsuit Component with Full Backend Integration
 * 
 * BACKEND FEATURES INTEGRATED:
 * - Meta Pixel tracking with advanced matching
 * - Google Analytics conversion tracking
 * - CRM submission
 * - Retell CRM submission
 * - EmailJS integration
 * - TrustedForm tracking
 * - Ad tracking parameters (gclid, gbraid, wbraid)
 */

const ThankYouPage = () => {
  return (
    <div className="relative w-full h-screen bg-white overflow-hidden">
      <div className="pt-10 flex justify-center">
        <img src={tylogo} alt="Connect with Attorney" className="h-9" />
      </div>

      <div className="mt-[90px] pb-[220px] flex flex-col items-center text-center px-6 z-10 relative">
        <div className="w-[96px] h-[96px] rounded-full flex items-center justify-center mb-6">
          <img src={successIcon} alt="Success" className="w-120 h-120" />
        </div>

        <h1 className="text-[26px] font-bold text-[#162766] mb-4">
          Thank you for sharing your story.
        </h1>

        <p className="text-[14px] leading-relaxed text-[#4B5563] max-w-[520px]">
          Based on your answers, you may qualify for compensation, and you deserve
          to be heard and represented. Next, an intake specialist from our team
          will contact you for a brief call to explain the next steps and share
          key details about this litigation and how it may apply to your situation.
        </p>

        <div className="mt-8 text-[13px] text-[#162766] flex gap-3">
          <a href="/Disclaimer" target="_blank" rel="noopener noreferrer" className="hover:text-blue-800 font-bold">
            Disclaimer
          </a>
          <span>|</span>
          <a href="/PrivacyPolicy" target="_blank" rel="noopener noreferrer" className="hover:text-blue-800 font-bold">
            Privacy Policy
          </a>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full z-0">
        <img src={tyBuildings} alt="Buildings" className="w-full" />
      </div>
    </div>
  );
};

const MobileThankYou = () => {
  return (
    <div className="md:hidden relative w-full min-h-screen bg-white overflow-hidden">
      <div className="pt-10 flex justify-center">
        <img src={tylogo} className="h-8" />
      </div>

      <div className="mt-20 px-6 text-center relative z-10 pb-48">
        <div className="w-[88px] h-[88px] mx-auto mb-6 rounded-full bg-[#162766] flex items-center justify-center">
          <svg width="42" height="32" viewBox="0 0 42 32" fill="none">
            <path
              d="M2 18L14 30L40 2"
              stroke="white"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2 className="text-[28px] font-bold text-[#162766] mb-4">
          Thank you for
          <br />
          sharing your story.
        </h2>

        <p className="text-[16px] leading-[22px] text-[#4B5563]">
          Based on your answers, you may qualify for compensation, and you deserve
          to be heard and represented. Next, an intake specialist from our team
          will contact you for a brief call to explain the next steps and share key
          details about this litigation and how it may apply to your situation.
        </p>

        <div className="mt-20 text-[13px] text-[#162766] flex justify-center gap-3">
          <a href="/Disclaimer" target="_blank" rel="noopener noreferrer" className="hover:text-blue-800 font-bold">
            Disclaimer
          </a>
          <span>|</span>
          <a href="/PrivacyPolicy" target="_blank" rel="noopener noreferrer" className="hover:text-blue-800 font-bold">
            Privacy Policy
          </a>
        </div>
      </div>

      <img src={tyBuildingsMobile} className="absolute bottom-0 left-0 w-full" />
    </div>
  );
};

const RideshareSexualAssaultLawsuitC = () => {
  // Meta Pixel ID
  const META_PIXEL_ID = ""; //1679236040107644 input pixel id 
  
  // Refs for tracking
  let initialLandingUrl = useRef(null);
  const adTrackingRef = useRef({
    gclid: null,
    gbraid: null,
    wbraid: null,
  });

  const [showThankYou, setShowThankYou] = useState(false);
  const [showCallPopup, setShowCallPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [faqOpen, setFaqOpen] = useState({
  fee: true,
  records: false,
  support: false,
});

const toggleFaq = (key) =>
  setFaqOpen((prev) => ({ ...prev, [key]: !prev[key] }));


  // Form state for desktop
  const [desktopFormData, setDesktopFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    q1: "",
    q2: "",
    q3: "",
    consent: false,
  });

  // Form state for mobile
  const [mobileFormData, setMobileFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    q1: "",
    q2: "",
    q3: "",
    consent: false,
  });

  // Error state
  const [desktopErrors, setDesktopErrors] = useState({});
  const [mobileErrors, setMobileErrors] = useState({});
  const [desktopTouched, setDesktopTouched] = useState({});
  const [mobileTouched, setMobileTouched] = useState({});

  // ========== BACKEND HELPER FUNCTIONS ==========

  const getSourceUrl = () => {
    if (typeof window === "undefined") return "Unknown";
    if (!initialLandingUrl.current) {
      initialLandingUrl.current = window.location.href;
    }
    return initialLandingUrl.current;
  };

  const getIPAddress = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error("Failed to get IP address:", error);
      return "IP address not available";
    }
  };

  const getUSTimezone = (tz) => {
    if (!tz) return "unknown";
    if (tz.includes("New_York")) return "ET";
    if (tz.includes("Chicago")) return "CT";
    if (tz.includes("Denver")) return "MT";
    if (tz.includes("Los_Angeles")) return "PT";
    if (tz.includes("Phoenix")) return "MT";
    if (tz.includes("Anchorage")) return "AK";
    if (tz.includes("Honolulu")) return "HT";
    return "other";
  };

  const getTrustedFormData = () => {
  return new Promise((resolve) => {
    // Check both desktop and mobile forms
    const certUrl = document.getElementById('xxTrustedFormCertUrl')?.value ||
      document.getElementById('xxTrustedFormCertUrl_mobile')?.value;

    const tokenUrl = document.getElementById('xxTrustedFormCertToken')?.value ||
      document.getElementById('xxTrustedFormCertToken_mobile')?.value;

    const pingUrl = document.getElementById('xxTrustedFormPingUrl')?.value ||
      document.getElementById('xxTrustedFormPingUrl_mobile')?.value;

    if (!certUrl) {
      setTimeout(() => {
        const retryCertUrl = document.getElementById('xxTrustedFormCertUrl')?.value ||
          document.getElementById('xxTrustedFormCertUrl_mobile')?.value;
        const retryTokenUrl = document.getElementById('xxTrustedFormCertToken')?.value ||
          document.getElementById('xxTrustedFormCertToken_mobile')?.value;
        const retryPingUrl = document.getElementById('xxTrustedFormPingUrl')?.value ||
          document.getElementById('xxTrustedFormPingUrl_mobile')?.value;

        resolve({
          certId: retryCertUrl,
          tokenUrl: retryTokenUrl,
          pingUrl: retryPingUrl
        });
      }, 500);
    } else {
      resolve({
        certId: certUrl,
        tokenUrl: tokenUrl,
        pingUrl: pingUrl
      });
    }
  });
};

  // const saveToCRM = async ({ payload }) => {
  //   try {
  //     const ipAddress = await getIPAddress();
  //     const response = await fetch('https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //         countryName: 'USA',
  //         brandType: "Internal",
  //         brandName: 'Project 6',
  //         websiteName: 'Connect With Attorney',
  //         vertical: LeadVertical.RIDESHARE,
  //         formPath: '/rideshare-sa-lawsuit-c',
  //         formname: 'Rideshare Sexual Assault Lawsuit lander C',
  //         data: {
  //           submissionDate: new Date().toLocaleString(),
  //           name: payload.fullName,
  //           firstName: payload.fullName.split(' ')[0] || '',
  //           lastName: payload.fullName.split(' ').slice(1).join(' ') || '',
  //           email: payload.email,
  //           phone: payload.phone,
  //           q1: payload.q1,
  //           q2: payload.q2,
  //           q3: payload.q3,
  //           injuryType: "Sexual Assault",
  //           trustedFormCertUrl: payload.certId,
  //           trustedFormPingUrl: payload.pingUrl,
  //           trustedFormToken: payload.tokenUrl,
  //           ip_address: ipAddress,
  //           page_source: getSourceUrl(),
  //           gclid: payload.gclid,
  //           gbraid: payload.gbraid,
  //           wbraid: payload.wbraid,
  //         }
  //       })
  //     });
  //     return response.ok;
  //   } catch (e) {
  //     console.error('CRM submission error:', e);
  //     return false;
  //   }
  // };

  const sendToRetellCRM = async ({ payload }) => {
    try {
      const ipAddress = await getIPAddress();
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const submittedAtUTC = new Date().toISOString();
      const usTimezone = getUSTimezone(timezone);

      const retellPayload = {
        countryName: 'USA',
        brandType: "Internal",
        brandName: 'Project 6',
        websiteName: 'Connect With Attorney',
        vertical: LeadVertical.RIDESHARE,
        formPath: '/rideshare-sa-lawsuit-c',
        formname: 'Rideshare Sexual Assault Lawsuit Lander Form C',
        data: {
          submissionDate: new Date().toLocaleString(),
          fullName: payload.fullName,
          firstName: payload.fullName.split(' ')[0] || '',
          lastName: payload.fullName.split(' ').slice(1).join(' ') || '',
          phone: payload.phone,
          email: payload.email,
          wasOffenderUberLyftDriver: payload.q1,
          whatHappened: payload.q2,
          hasAttorney: payload.q3,
          timezone,
          usTimezone,
          submittedAtUTC,
          injuryType: "Sexual Assault",
          trustedFormCertUrl: payload.certId,
          trustedFormPingUrl: payload.pingUrl,
          trustedFormToken: payload.tokenUrl,
          ip_address: ipAddress,
          pageUrl: getSourceUrl(),
          gclid: payload.gclid,
          gbraid: payload.gbraid,
          wbraid: payload.wbraid,
        }
      };

      const res = await fetch(
        "https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata/retell",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(retellPayload),
        }
      );

      if (!res.ok) {
        const text = await res.text();
        console.error("Retell CRM failed:", text);
      }
    } catch (err) {
      console.error("Retell CRM error:", err);
    }
  };

  // ========== VALIDATION FUNCTIONS ==========

  const validateEmail = (email) => {
    const normalizedEmail = normalizeEmail(email);
    return isValidEmail(normalizedEmail);
  };

  const validatePhone = (phone) => {
    const normalizedPhone = normalizePhone(phone, { defaultCountryCode: "1" });
    return isValidPhoneDigits(normalizedPhone);
  };

  const validateForm = (formData) => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full name is required";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = "Please enter a valid 10-digit phone number";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.q1) {
      newErrors.q1 = "Please answer this question";
    }

    if (!formData.q2) {
      newErrors.q2 = "Please answer this question";
    }

    if (!formData.q3) {
      newErrors.q3 = "Please answer this question";
    }

    if (!formData.consent) {
      newErrors.consent = "You must agree to the terms to continue";
    }

    return newErrors;
  };

  // ========== FORM SUBMISSION HANDLERS ==========

  const handleDesktopSubmit = async (e) => {
    e.preventDefault();

    setDesktopTouched({
      fullName: true,
      phone: true,
      email: true,
      q1: true,
      q2: true,
      q3: true,
      consent: true,
    });

    const newErrors = validateForm(desktopFormData);
    setDesktopErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsSubmitting(true);

      const trustedFormData = await getTrustedFormData();

      const payload = {
        ...desktopFormData,
        ...trustedFormData,
        gclid: adTrackingRef.current.gclid,
        gbraid: adTrackingRef.current.gbraid,
        wbraid: adTrackingRef.current.wbraid,
      };

      try {
        
        await sendToRetellCRM({ payload });
        
        Promise.all([
          RideshareSALawsuitSendAdminEmail({ formData: payload }),
          RideshareSALawsuitSendUserEmail({ formData: payload })
        ]).catch(err => {
          console.error("Email sending failed:", err);
        });

        
          setShowThankYou(true);

          // Track Lead event with advanced matching
          const userData = buildAdvancedMatching({
            email: payload.email,
            phoneNumber: payload.phone
          });
          trackEventWithUserData('CompleteRegistration', userData);

          // Google Ads conversion tracking
          if (window.gtag) {
            window.gtag('event', 'conversion', {
              send_to: 'AW-32222222/dccxcvfDummy', //change later
              value: 1.0,
              currency: 'USD'
            });
          }
        
      } catch (error) {
        console.error('Error submitting form:', error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleMobileSubmit = async (e) => {
    e.preventDefault();

    setMobileTouched({
      fullName: true,
      phone: true,
      email: true,
      q1: true,
      q2: true,
      q3: true,
      consent: true,
    });

    const newErrors = validateForm(mobileFormData);
    setMobileErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsSubmitting(true);

      const trustedFormData = await getTrustedFormData();

      const payload = {
        ...mobileFormData,
        ...trustedFormData,
        gclid: adTrackingRef.current.gclid,
        gbraid: adTrackingRef.current.gbraid,
        wbraid: adTrackingRef.current.wbraid,
      };

      try {
        
        await sendToRetellCRM({ payload });
        
        Promise.all([
          RideshareSALawsuitSendAdminEmail({ formData: payload }),
          RideshareSALawsuitSendUserEmail({ formData: payload })
        ]).catch(err => {
          console.error("Email sending failed:", err);
        });

        
          setShowThankYou(true);

          // Track Lead event with advanced matching
          const userData = buildAdvancedMatching({
            email: payload.email,
            phoneNumber: payload.phone
          });
          trackEventWithUserData('CompleteRegistration', userData);

          // Google Ads conversion tracking
          if (window.gtag) {
            window.gtag('event', 'conversion', {
              send_to: 'AW-322222/IzbXCNfAz_IbEJTf2eRCdummy', //change later
              value: 1.0,
              currency: 'USD'
            });
          }
        
      } catch (error) {
        console.error('Error submitting form:', error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  // ========== USEEFFECTS FOR TRACKING ==========

  // Initialize Meta Pixel
  useEffect(() => {
    ensureMetaPixel(META_PIXEL_ID);
    if (window.fbq) window.fbq("track", "PageView");
  }, []);

  useEffect(() => {
  if (showThankYou && window.fbq) {
    window.fbq('track', 'Thank You');
  }
}, [showThankYou]);

  // Capture ad tracking parameters
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    adTrackingRef.current = {
      gclid: params.get('gclid'),
      gbraid: params.get('gbraid'),
      wbraid: params.get('wbraid'),
    };
  }, []);

  // Initialize Google Tag Manager
  useEffect(() => {
    if (document.getElementById('gtag-depo')) return;

    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-3222222'; //change later
    gtagScript.id = 'gtag-depo';

    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-32222222');
    `;

    document.head.appendChild(gtagScript);
    document.head.appendChild(inlineScript);
  }, []);

  if (showThankYou) {
    return (
      <>
        <div className="hidden md:block">
          <ThankYouPage />
        </div>
         <MobileThankYou />
      </>
    );
  }

  return (
    <div className="w-full min-h-screen bg-white">
      {/* TrustedForm Hidden Fields */}
      {/* <input type="hidden" id="xxTrustedFormCertUrl" name="xxTrustedFormCertUrl" />
      <input type="hidden" id="xxTrustedFormCertToken" name="xxTrustedFormCertToken" />
      <input type="hidden" id="xxTrustedFormPingUrl" name="xxTrustedFormPingUrl" /> */}

      {/* ================= DESKTOP VIEW ================= */}
      <div className="hidden md:block">
        {/* ===== HEADER ===== */}
        <header className="w-full bg-[#162766]  ">
          <div className="max-w-[1150px] mx-auto px-10 py-3 flex items-center justify-between">
            <img src={logo} alt="Connect with Attorney" className="h-7" />

            <a
                href="tel:18882021350"
                className="
                    flex items-center gap-3
                    bg-[#F8D216]
                    text-[#162766]
                    px-3 py-2
                    rounded-[8px]
                    font-semibold
                    shadow-sm
                    hover:bg-[#E5C414]
                    transition-colors
                    
                "
                >
                <span
                    className="
                    flex items-center justify-center
                    w-6 h-6
                    bg-[#162766]
                    rounded-[10px]
                    "
                >
                    <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                        d="M22 16.92V20A2 2 0 0 1 19.82 22
                        A19.86 19.86 0 0 1 2 4.18
                        A2 2 0 0 1 4 2H7.09
                        A2 2 0 0 1 9.09 3.72
                        C9.27 4.88 9.6 6.01 10.07 7.08
                        A2 2 0 0 1 9.62 9.21L8.21 10.62
                        A16 16 0 0 0 13.38 15.79L14.79 14.38
                        A2 2 0 0 1 16.92 13.93
                        C17.99 14.4 19.12 14.73 20.28 14.91
                        A2 2 0 0 1 22 16.92Z"
                        fill="#F8D216"
                    />
                    </svg>
                </span>

                <span className="text-[14px] tracking-wide">
                    (888) 202 1350
                </span>
                </a>

          </div>
        </header>

        {/* ===== HERO SECTION ===== */}
        <section
            className="w-full overflow-hidden min-h-[62vh]"
            style={{
                backgroundImage: `url(${bgC})`, // ← use your attached image import
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
            }}
        >

          <div
            className="
              max-w-[1200px]
              mx-auto
              px-10
              grid
              grid-cols-[auto_auto]
              justify-center
              gap-40
              transform
              scale-[0.88]
              xl:scale-[0.91]
              origin-top
            "
          >
            {/* ===== LEFT CONTENT ===== */}
            <div className="pt-0 pb-5 mt-20 text-white flex justify-center">

              <div className="max-w-[460px] text-left">
                <h1 className="text-[38px] leading-tight font-bold mb-4">
                  <span className="font-normal">Sexually Assaulted in <br /> an Uber or Lyft?</span>
                  
                    <span className="font-semibold"> Get a <br /> Free Case Review</span>
                </h1>

                <p className="max-w-[420px] text-[16px] text-white mb-4 leading-[1.6]">
                  Uber/Lyft assault claims often depend on proof of the ride and the type of contact involved. Start with a private screening to see if you meet the requirements.   
                </p>

              </div>
            </div>

            {/* ===== RIGHT FORM ===== */}
            <div className="pt-10 pb-4 flex justify-center">
              <div className="bg-white text-[#162766] rounded-xl shadow-xl overflow-hidden w-full max-w-[420px]">
                <div className="w-full h-[4px] bg-[#F8D216]" />

                <div className="px-6 py-4">
                  <h2 className="font-poppins text-[18px] font-bold leading-4 text-center mb-4">
                    Get Your Free Case Review Today
                  </h2>

                  <form onSubmit={handleDesktopSubmit} className="space-y-4">
                    <input type="hidden" id="xxTrustedFormCertUrl" name="xxTrustedFormCertUrl" />
                    <input type="hidden" id="xxTrustedFormCertToken" name="xxTrustedFormCertToken" />
                    <input type="hidden" id="xxTrustedFormPingUrl" name="xxTrustedFormPingUrl" />
                    <div className="flex flex-col gap-1">
                      <label className="text-[12px] font-medium">Full Name</label>
                      <input
                        type="text"
                        placeholder="John Smith"
                        value={desktopFormData.fullName}
                        onChange={(e) =>
                          setDesktopFormData({ ...desktopFormData, fullName: e.target.value })
                        }
                        className={`w-full border rounded-md px-3 py-2 text-[13px] ${
                          desktopTouched.fullName && desktopErrors.fullName
                            ? "border-red-500 focus:border-red-500"
                            : "border-[#D7DBEA]"
                        }`}
                      />
                      {desktopTouched.fullName && desktopErrors.fullName && (
                        <span className="text-[11px] text-red-500">{desktopErrors.fullName}</span>
                      )}
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <div className="flex flex-col gap-1">
                        <label className="text-[12px] font-medium">Phone Number</label>
                        <input
                          type="text"
                          placeholder="(888) 333-4455"
                          value={desktopFormData.phone}
                          onChange={(e) => {
                            const input = e.target.value.replace(/\D/g, '');
                            let formatted = '';

                            if (input.length > 0) {
                              formatted = '(' + input.substring(0, 3);
                              if (input.length > 3) {
                                formatted += ') ' + input.substring(3, 6);
                              }
                              if (input.length > 6) {
                                formatted += '-' + input.substring(6, 10);
                              }
                            }

                            setDesktopFormData({ ...desktopFormData, phone: formatted });
                          }}
                          maxLength={14}
                          className={`w-full border rounded-md px-3 py-2 text-[13px] ${
                            desktopTouched.phone && desktopErrors.phone
                              ? "border-red-500 focus:border-red-500"
                              : "border-[#D7DBEA]"
                          }`}
                        />
                        {desktopTouched.phone && desktopErrors.phone && (
                          <span className="text-[11px] text-red-500">{desktopErrors.phone}</span>
                        )}
                      </div>

                      <div className="flex flex-col gap-1">
                        <label className="text-[12px] font-medium">Email</label>
                        <input
                          type="email"
                          placeholder="e.g. john.smith@mail.com"
                          value={desktopFormData.email}
                          onChange={(e) =>
                            setDesktopFormData({ ...desktopFormData, email: e.target.value })
                          }
                          className={`w-full border rounded-md px-3 py-2 text-[13px] ${
                            desktopTouched.email && desktopErrors.email
                              ? "border-red-500 focus:border-red-500"
                              : "border-[#D7DBEA]"
                          }`}
                        />
                        {desktopTouched.email && desktopErrors.email && (
                          <span className="text-[11px] text-red-500">{desktopErrors.email}</span>
                        )}
                      </div>
                    </div>

                    {/* Q1 - Radio  */}
                    <div className="space-y-1">
                      <p className="text-[13px] font-semibold">
                        Q1. Was the offender your Uber/Lyft driver during a ride?
                      </p>
                      <div className="grid grid-cols-2 gap-3">
                        {["Yes", "No"].map((opt) => (
                          <label
                            key={opt}
                            className="flex items-center gap-2 px-3 py-2.5 rounded-md border border-[#D7DBEA] cursor-pointer has-[:checked]:bg-[#E1E4F0]"
                          >
                            <input
                              type="radio"
                              name="q1"
                              value={opt}
                              checked={desktopFormData.q1 === opt}
                              onChange={(e) => {
                                setDesktopFormData({ ...desktopFormData, q1: e.target.value });
                              }}
                              className="peer hidden"
                            />

                            <span
                              className="
                                w-4 h-4
                                rounded-full
                                border border-[#162766]
                                flex items-center justify-center
                                peer-checked:border-[#162766]
                                peer-checked:bg-[#162766]
                                [&>svg]:hidden
                                peer-checked:[&>svg]:block
                              "
                            >
                              <svg
                                width="8"
                                height="6"
                                viewBox="0 0 9 7"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.07764 0.551758C8.14631 0.48331 8.25808 0.483174 8.32666 0.551758C8.39519 0.620347 8.39509 0.732131 8.32666 0.800781L3.44775 5.67773C3.37274 5.75272 3.27061 5.79492 3.16455 5.79492C3.05859 5.79491 2.95731 5.7526 2.88232 5.67773L0.550293 3.3457C0.482781 3.27815 0.483011 3.16828 0.550293 3.10059C0.617975 3.0329 0.72774 3.0329 0.79541 3.10059L2.80811 5.11426L3.16162 5.46777L8.07764 0.551758Z"
                                  fill="#F8D216"
                                  stroke="#F8D216"
                                  strokeWidth="0.5"
                                />
                              </svg>
                            </span>
                            <span className="text-[13px] font-medium">{opt}</span>
                          </label>
                        ))}
                      </div>
                      {desktopTouched.q1 && desktopErrors.q1 && (
                        <span className="text-[11px] text-red-500">{desktopErrors.q1}</span>
                      )}
                    </div>

                    {/* Q2 - Dropdown (was previously Q1, unchanged markup) */}
                    <div className="space-y-1">
                      <label className="text-[13px] font-semibold">
                        Q2. What best describes what happened?
                      </label>
                      <select
                        value={desktopFormData.q2}
                        onChange={(e) =>
                          setDesktopFormData({ ...desktopFormData, q2: e.target.value })
                        }
                        className={`w-full border rounded-md px-3 py-2.5 text-[13px] ${
                          desktopTouched.q2 && desktopErrors.q2
                            ? "border-red-500 focus:border-red-500"
                            : "border-[#D7DBEA]"
                        }`}
                      >
                        <option value="">Please select an option</option>
                        <option value="Forced sexual act (forced oral, forced manual stimulation)">Forced sexual act (forced oral, forced manual stimulation)</option>
                        <option value="Non-consensual sexual touching or kissing of a sexual body part">Non-consensual sexual touching or kissing of a sexual body part</option>
                        <option value="Indecent exposure / masturbation">Indecent exposure / masturbation</option>
                        <option value="Kidnapping / false imprisonment with overt sexual or extreme physical threats">Kidnapping / false imprisonment with overt sexual or extreme physical threats</option>
                        <option value="Other">Other</option>
                        <option value="None of the above">None of the above</option>
                      </select>
                      {desktopTouched.q2 && desktopErrors.q2 && (
                        <span className="text-[11px] text-red-500">{desktopErrors.q2}</span>
                      )}
                    </div>

                    {/* Q3 - unchanged */}
                    <div className="space-y-1">
                      <p className="text-[13px] font-semibold">
                        Q3. Are you currently working with an attorney or have you already filed a rideshare claim for this incident?
                      </p>
                      <div className="grid grid-cols-2 gap-3">
                        {["Yes", "No"].map((opt) => (
                          <label
                            key={opt}
                            className="flex items-center gap-2 px-3 py-2.5 rounded-md border border-[#D7DBEA] cursor-pointer has-[:checked]:bg-[#E1E4F0]"
                          >
                            <input
                              type="radio"
                              name="q3"
                              value={opt}
                              checked={desktopFormData.q3 === opt}
                              onChange={(e) => {
                                setDesktopFormData({ ...desktopFormData, q3: e.target.value });
                              }}
                              className="peer hidden"
                            />

                            <span
                              className="
                                w-4 h-4
                                rounded-full
                                border border-[#162766]
                                flex items-center justify-center
                                peer-checked:border-[#162766]
                                peer-checked:bg-[#162766]
                                [&>svg]:hidden
                                peer-checked:[&>svg]:block
                              "
                            >
                              <svg
                                width="8"
                                height="6"
                                viewBox="0 0 9 7"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.07764 0.551758C8.14631 0.48331 8.25808 0.483174 8.32666 0.551758C8.39519 0.620347 8.39509 0.732131 8.32666 0.800781L3.44775 5.67773C3.37274 5.75272 3.27061 5.79492 3.16455 5.79492C3.05859 5.79491 2.95731 5.7526 2.88232 5.67773L0.550293 3.3457C0.482781 3.27815 0.483011 3.16828 0.550293 3.10059C0.617975 3.0329 0.72774 3.0329 0.79541 3.10059L2.80811 5.11426L3.16162 5.46777L8.07764 0.551758Z"
                                  fill="#F8D216"
                                  stroke="#F8D216"
                                  strokeWidth="0.5"
                                />
                              </svg>
                            </span>
                            <span className="text-[13px] font-medium">{opt}</span>
                          </label>
                        ))}
                      </div>
                      {desktopTouched.q3 && desktopErrors.q3 && (
                        <span className="text-[11px] text-red-500">{desktopErrors.q3}</span>
                      )}
                    </div>

                    {/* Consent + submit unchanged */}
                    <div>
                      <label className="flex items-start gap-2 text-[10.5px] leading-snug text-[#5A627A]">
                        <input
                          type="checkbox"
                          checked={desktopFormData.consent}
                          onChange={(e) => {
                            setDesktopFormData({ ...desktopFormData, consent: e.target.checked });
                          }}
                          className="mt-[2px] accent-[#162766]"
                        />
                        <span>
                          I agree to the <a href="/PrivacyPolicy" target="_blank" rel="noopener noreferrer" className="hover:text-blue-800 font-bold">Privacy Policy</a>{' '}
                          and <a href="/Disclaimer" target="_blank" rel="noopener noreferrer" className="hover:text-blue-800 font-bold">Disclaimer</a> and give my express written consent,
                          affiliates and/or lawyer to contact you at the number provided above, even if this number is a wireless number or if I am presently listed on a Do Not Call list. 
                          I understand that I may be contacted by telephone, email, text message or mail regarding case options and that I may be called using automatic dialing equipment. 
                          Message and data rates may apply. My consent does not require purchase. This is Legal advertising.
                        </span>
                      </label>
                      {desktopTouched.consent && desktopErrors.consent && (
                        <span className="text-[11px] text-red-500 block mt-1">
                          {desktopErrors.consent}
                        </span>
                      )}
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className={`w-full bg-[#F8D216] text-[#162766] tracking-[0.15em] font-bold py-2.5 rounded-lg hover:bg-[#E5C414] transition-colors flex items-center justify-center gap-2 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
                    >
                      {isSubmitting ? (
                        <>
                          <div className="w-5 h-5 border-2 border-[#162766] border-t-transparent rounded-full animate-spin"></div>
                          <span>SUBMITTING...</span>
                        </>
                      ) : (
                        'REVIEW MY CASE'
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>


        {/* ===== UNDERSTANDING SECTION ===== */}
        <section className="relative w-full min-h-[520px] pt-10 overflow-hidden">
            {/* ===== RIGHT HALF IMAGE (FULL HEIGHT) ===== */}
            <div
                className="absolute top-0 right-0 h-full w-[45%] bg-cover"
                style={{
                backgroundImage: `url(${womanLawyerC})`,
                }}
            />

            {/* ===== LEFT HALF BACKGROUND ===== */}
            <div className="absolute top-0 left-0 h-full w-[55%] bg-[#EBEEFF]" />

            {/* ===== CONTENT LAYER ===== */}
            <div className="relative max-w-[1200px] mx-auto px-10 h-full">
                <div className="grid grid-cols-2 h-full items-center">
                
                {/* LEFT CONTENT */}
                <div className="max-w-[520px] text-[#162766]">
                    <h2 className="text-[32px] leading-tight font-normal mt-6 mb-6">
                    Your safety was violated. <br />
                     <span className="font-semibold"> You deserve support </span> and <br />
                     <span className="font-semibold"> a path forward.</span>
                    </h2>

                    <p className="text-[15px] font-lato leading-[1.7] text-[#162766] mb-6 max-w-[440px]">
                    A rideshare is supposed to be a safe way home, not a situation where you’re trapped, threatened, or touched without consent. If you were sexually assaulted by an Uber or Lyft driver, you may be eligible to pursue compensation, especially when the assault involved physical contact, happened in or around the vehicle, and you can provide (or obtain) your ride receipt.   
                    </p>

                    <p className="text-[12px] font-lato leading-[1.7] text-[#162766] mb-6 max-w-[420px]">
                    What happened is not your fault. A case review can help you understand what qualifies and what steps protect your rights.   
                    </p>
                </div>

                {/* RIGHT COLUMN IS EMPTY BY DESIGN */}
                <div />
                </div>
            </div>

            {/* ===== CTA OVER IMAGE ===== */}
            <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="
                absolute
                bottom-0
                right-0
                bg-[#1B2B6B]
                text-white
                text-[14px]
                font-semibold
                px-6
                py-3
                rounded-tl-md
                hover:bg-[#162766]
                transition-colors
                "
            >
                See If You Qualify
            </button>
        </section>


        {/* ===== 3 CARDS SECTION ===== */}
        <section className="w-full bg-white">
            {/* ===== YELLOW TOP LINE ===== */}
            <div className="w-full h-[8px] bg-[#F8D216]" />

            {/* ===== CONTENT ===== */}
            <div className="py-16">
                <div className="max-w-[1200px] mx-auto px-10">
                <div className="grid grid-cols-3 gap-8">

                    {/* CARD 1 */}
                    <div className="bg-white rounded-xl shadow-[0_6px_20px_rgba(0,0,0,0.08)] overflow-hidden">
                    <div className="bg-[#162766] px-6 py-8 min-h-[130px] flex items-center justify-between">

                        <h3 className="text-white text-[24px] font-semibold uppercase leading-snug">
                        IT HAPPENED <br /> DURING THE RIDE
                        </h3>
                        <img src={symptomsarentsmall} alt="" className="w-12 h-12" />
                    </div>

                    <div className="px-6 py-6 text-[16px] font-lato leading-[1.7] font-normal text-[#162766]/90">
                       If the assault occurred in the car, just outside it, or as part of the ride situation, it may qualify, even if it continued after the drop-off.
                    </div>
                    </div>

                    {/* CARD 2 */}
                    <div className="bg-white rounded-xl shadow-[0_6px_20px_rgba(0,0,0,0.08)] overflow-hidden">
                    <div className="bg-[#162766] px-6 py-8 min-h-[130px] flex items-center justify-between">
                        <h3 className="text-white text-[24px] font-semibold uppercase leading-snug">
                        MEDICAL, THERAPY <br />  & TIME OFF
                        </h3>
                        <img src={dollarbag} alt="" className="w-12 h-12" />
                    </div>

                    <div className="px-6 py-6 text-[16px] font-lato leading-[1.7] font-normal text-[#162766]/90">
                        After an assault, costs can include ER visits, counseling, medication, missed work, and long-term care. Compensation may help relieve that burden.  
                    </div>
                    </div>

                    {/* CARD 3 */}
                    <div className="bg-white rounded-xl shadow-[0_6px_20px_rgba(0,0,0,0.08)] overflow-hidden">
                    <div className="bg-[#1B2B6B] px-6 py-8 min-h-[130px] flex items-center justify-between">
                        <h3 className="text-white text-[24px] font-semibold uppercase leading-snug">
                        DEADLINES CAN <br /> LIMIT CLAIMS
                        </h3>
                        <img src={symptomsarentsmall} alt="" className="w-12 h-12" />
                    </div>

                    <div className="px-6 py-6 text-[16px] font-lato leading-[1.7] font-normal text-[#162766]/90">
                        Filing windows vary by state. A quick review can confirm whether your case may still be within the statute of limitations.
                    </div>
                    </div>

                </div>
                </div>
            </div>
        </section>


        {/* ===== Chart section ===== */}
        <section className="relative w-full bg-white pb-24 overflow-hidden">
            <div className="max-w-[1200px] mx-auto px-10">
                <div className="grid grid-cols-2 gap-20 items-center">
                
                {/* ===== LEFT IMAGE ===== */}
                <div className="flex justify-center">
                    <img
                    src={statistics}
                    alt="Depo-Provera Statistics"
                    className="max-w-[360px] w-full h-auto"
                    />
                </div>

                {/* ===== RIGHT CONTENT ===== */}
                <div className="text-[#162766]">
                    <h2 className="text-[24px] font-semibold mb-5">
                    What Typically Matters in Rideshare Assault Claims?  
                    </h2>

                    <ul className="space-y-4 text-[16px] font-lato leading-[1.7] text-[#162766] list-disc pl-5 max-w-[520px]">
                    <li>
                        The offender was an Uber or Lyft driver (not another passenger).  
                    </li>
                    <li>
                        The incident involved physical sexual contact (not only messages or verbal harassment).  
                    </li>
                    <li>
                        You can provide the ride receipt or confirm you can obtain it.  
                    </li>
                    <li>
                        You told someone Uber/Lyft, police, a medical provider, a therapist, or a trusted person, near the time it happened.  
                    </li>
                    <li>
                        The incident is within the time limit allowed in your state (some states have extended windows).  
                    </li>
                    </ul>
                </div>
                </div>
            </div>

            {/* ===== CTA BUTTON (BOTTOM RIGHT OF SECTION) ===== */}
            <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="
                absolute
                bottom-0
                right-0
                bg-[#1B2B6B]
                text-white
                text-[14px]
                font-semibold
                px-6
                py-3
                rounded-tl-md
                hover:bg-[#162766]
                transition-colors
                "
            >
                See If You Qualify
            </button>
        </section>


        {/* ===== ELABORATION SECTION ===== */}
        <section className="relative w-full min-h-[880px] pt-16 overflow-hidden">
            {/* ===== TOP YELLOW LINE ===== */}
            <div className="absolute top-0 left-0 w-full h-[8px] bg-[#F8D216] z-20" />

            {/* ===== BOTTOM YELLOW LINE ===== */}
            

            {/* ===== RIGHT HALF IMAGE (FULL HEIGHT) ===== */}
            <div
                className="absolute top-0 right-0 h-full w-[45%] bg-cover bg-center"
                style={{
                backgroundImage: `url(${rideC})`,
                }}
            />

            {/* ===== LEFT HALF BACKGROUND ===== */}
            <div className="absolute top-0 left-0 h-full w-[55%] bg-[#EBEEFF]" />

            {/* ===== CONTENT LAYER ===== */}
            <div className="relative max-w-[1200px] mx-auto px-10 h-full z-10">
                <div className="grid grid-cols-2 h-full items-center">

                {/* LEFT CONTENT */}
                <div className="max-w-[540px] text-[#1B2B6B] mt-14">
                    <h2 className="text-[35px] leading-tight font-normal mb-4">
                    You don't have to carry this alone. <br /> We help you <span className="font-semibold">take the next step.</span>
                    </h2>

                    <p className="text-[18px] font-lato leading-tight text-[#162766]  mb-4 max-w-[500px]">
                    <br />
                     After a rideshare assault, survivors often feel overwhelmed, unsure what counts, who will believe them, and what proof matters. Our job is to make the first step simple, respectful, and private.  
                    </p>

                    <p className="text-[16px] font-lato leading-[1.7] text-[#162766] mb-6">
                    <br />
                    <span className="font-semibold">CONFIDENTIAL CASE REVIEW</span>{" "}
                    <span className="font-normal">
                         Share what happened in a secure screening. We focus on the facts that drive eligibility, ride receipt, location/timing, and type of contact
                    </span>
                    </p>

                    <p className="text-[16px] font-lato leading-[1.7] text-[#162766] mb-6">
                    <span className="font-semibold">TRAUMA-INFORMED SUPPORT</span> You control the pace. We can connect you with attorneys who handle these cases with sensitivity, not pressure. 
                    </p>

                    <p className="text-[16px] font-lato leading-[1.7] text-[#162766] mb-6">
                    <span className="font-semibold">DOCUMENTATION SUPPORT</span> If you don’t have the ride receipt or records yet, we’ll tell you what to request and what details to gather so your case review is stronger. 
                    </p>

                    <p className="text-[16px] font-lato leading-[1.7] text-[#162766]">
                    <span className="font-semibold">NO UPFRONT COST</span> Many attorneys work on contingency, meaning you typically pay nothing unless compensation is recovered.
                    </p>
                </div>

                {/* RIGHT COLUMN EMPTY BY DESIGN */}
                <div />
                </div>
            </div>

            {/* ===== CTA OVER IMAGE ===== */}
            <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="
                absolute
                bottom-0
                right-0
                bg-[#1B2B6B]
                text-white
                text-[14px]
                font-semibold
                px-6
                pt-2
                pb-3
                rounded-tl-md
                hover:bg-[#162766]
                transition-colors
                z-20
                "
            >
                See If You Qualify
            </button>
            <div className="absolute bottom-0 left-0 w-full h-[8px] bg-[#F8D216] z-20" />
        </section>


        {/* === blue bg text section */}
        <section className="w-full bg-[#162B6F] py-20">
            <div className="max-w-[1200px] mx-auto px-10">
                <div className="grid grid-cols-2 gap-24 items-center">

                {/* LEFT CONTENT */}
                <div className="text-white text-center flex flex-col items-center">
                    <h2 className="text-[35px] leading-tight font-normal mb-6">
                    <span className="font-semibold">Confidential Case Reviews</span>
                    </h2>

                    {/* Centered divider line */}
                    <div className="w-[220px] h-[3px] bg-[#F8F9FA]/40 mb-6" />

                    <p className="text-[20px] leading-[1.65] text-white/90 max-w-[420px]">
                    for Uber & Lyft Assault Claims  
                    </p>
                </div>

                {/* RIGHT CONTENT */}
                <div className="text-white text-[16px] text-center mx-auto font-lato font-medium leading-[1.7] max-w-[480px]">
                    ConnectwithAttorney helps screen rideshare sexual assault cases and connect eligible survivors with attorneys. Eligibility often depends on driver involvement, physical contact, receipt verification, reporting, and state deadlines. If your incident matches the criteria, you may be able to pursue compensation.  
                </div>

                </div>
            </div>
        </section>


        {/* ===== FAQ SECTION ===== */}
        <section className="relative w-full overflow-hidden">
            <div className="grid grid-cols-[1.15fr_0.85fr] min-h-[640px]">

                {/* LEFT (WHITE) */}
                <div className="bg-white px-10 py-16">
                <div className="max-w-[560px] ml-auto mr-10">
                    <h2 className="text-[30px] leading-tight font-normal text-[#1B2B6B] mb-8">
                    <span className="font-semibold">We’ll help you</span> understand what <br /> qualifies,
                    <span className="font-semibold"> step by step.</span>
                    </h2>

                    <p className="text-[20px]  font-lato leading-[1.25] text-[#162766] mb-6">
                    You don’t need to understand legal language to take action. Our screening is designed to match the actual criteria that law firms require, so you don’t waste time.  
                    </p>

                    {/* FAQ */}
                    <div className="border border-[#E2E6F3] rounded-lg overflow-hidden">

                      {/* No Win No Fee */}
                      <button
                        onClick={() => toggleFaq("fee")}
                        className={`w-full px-5 py-4 flex justify-between items-center font-lato text-left text-[16px]
                        transition-colors duration-300
                        ${faqOpen.fee ? "bg-[#162766] text-white" : "bg-[#F5F7FF] text-[#1B2B6B]"}`}
                      >
                        No Win, No Fee
                        <img
                          src={faqOpen.fee ? faqArrow : faqArrowD}
                          alt="toggle"
                          className="w-4 h-4 transition-all duration-300"
                        />
                      </button>

                      <div
                        className={`overflow-hidden transition-all duration-400 ease-in-out
                        ${faqOpen.fee ? "max-h-[200px] opacity-100" : "max-h-0 opacity-0"}`}
                      >
                        <div className="px-5 py-4 text-[16px] font-lato leading-[1.6] bg-white">
                            Many claims are handled on contingency—no upfront fees in most cases.
                        </div>
                      </div>

                      {/* Medical Records */}
                      <button
                        onClick={() => toggleFaq("records")}
                        className={`w-full px-5 py-4 flex justify-between items-center font-lato text-left text-[16px]
                        transition-colors duration-300 border-t border-[#E2E6F3]
                        ${faqOpen.records ? "bg-[#162766] text-white" : "bg-[#F5F7FF] text-[#1B2B6B]"}`}
                      >
                        Evidence That Matters
                        <img
                          src={faqOpen.records ? faqArrow : faqArrowD}
                          alt="toggle"
                          className="w-4 h-4 transition-all duration-300"
                        />
                      </button>

                      <div
                        className={`overflow-hidden transition-all duration-400 ease-in-out
                        ${faqOpen.records ? "max-h-[200px] opacity-100" : "max-h-0 opacity-0"}`}
                      >
                        <div className="px-5 py-4 text-[16px] font-lato leading-[1.6] text-[#3E4A6B] bg-white">
                          Ride receipt, timeline, reporting, and any medical/therapy records can strengthen a claim.
                        </div>
                      </div>

                      {/* Support */}
                      <button
                        onClick={() => toggleFaq("support")}
                        className={`w-full px-5 py-4 flex justify-between items-center font-lato text-left text-[16px]
                        transition-colors duration-300 border-t border-[#E2E6F3]
                        ${faqOpen.support ? "bg-[#162766] text-white" : "bg-[#F5F7FF] text-[#1B2B6B]"}`}
                      >
                        Protect Your Deadline
                        <img
                          src={faqOpen.support ? faqArrow : faqArrowD}
                          alt="toggle"
                          className="w-4 h-4 transition-all duration-300"
                        />
                      </button>

                      <div
                        className={`overflow-hidden transition-all duration-400 ease-in-out
                        ${faqOpen.support ? "max-h-[200px] opacity-100" : "max-h-0 opacity-0"}`}
                      >
                        <div className="px-5 py-4 text-[16px] font-lato leading-[1.6] text-[#3E4A6B] bg-white">
                          State time limits vary. A review helps confirm whether you may still be eligible.
                        </div>
                      </div>

                    </div>

                </div>
                </div>

                {/* RIGHT (LAVENDER) */}
                <div className="bg-[#EBEEFF] px-10 py-16 flex items-center">
                <div className="max-w-[400px]">
                    <h3 className="text-[31px] font-lato leading-tight font-normal text-[#1B2B6B] mb-6">
                    Why survivors choose ConnectwithAttorney? 
                    </h3>
                    <p className="text-[16px] font-lato leading-[1.65] text-[#162766] mb-6">
                        We keep the process clear and respectful, especially when you’re dealing with trauma and stress. Our screening is designed around high-intent criteria, including:
                    </p>

                    <ul className="space-y-4 text-[14.5px] leading-[1.7] text-[#162766] list-disc pl-5 max-w-[520px]">
                    <li>
                        Assault by an Uber/Lyft driver     
                    </li>
                    <li>
                        Physical contact (including qualifying tiers) 
                    </li>
                    <li>
                        Receipt confirmation    
                    </li>
                    <li>
                        Reporting pathway (rideshare company, police, medical, therapist, or trusted person)    
                    </li>
                    <li>
                        Deadline checks based on your state     
                    </li>
                    </ul>
                </div>
                </div>
            </div>

            {/* CTA */}
            <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="absolute bottom-0 right-0 bg-[#1B2B6B] text-white text-[14px] font-semibold px-6 pt-2 pb-3 rounded-tl-md hover:bg-[#162766]"
            >
                See If You Qualify
            </button>

            {/* Bottom Yellow Line */}
            <div className="absolute bottom-0 left-0 w-full h-[6px] bg-[#F8D216]" />
        </section>


        {/* ===== FOOTER ===== */}
        <section className="w-full bg-[#162B6F] py-10">
          <div className="max-w-[1200px] mx-auto px-6 flex flex-col items-center text-center">
            <h2 className="text-[32px] leading-[40px] font-semibold text-white">
              Ready To Get a Free Rideshare Sexual <br /> Assault Lawsuit Review?
            </h2>

            <div className="w-[44px] h-[3px] bg-[#F4C430] mt-4 mb-6" />

            <p className="text-[28px] leading-[28px] text-white/90 mb-8">
              Contact our legal partners today.
            </p>

            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="bg-[#F9D51C] text-[#0E1E4D] text-[14px] font-bold tracking-widest h-[44px] w-[240px] rounded-[6px]"
            >
              GET HELP NOW
            </button>
          </div>
        </section>
      </div>

      {/* ================= MOBILE HERO ================= */}
    <div
    className="md:hidden w-full min-h-[320px] bg-cover bg-center relative"
    style={{
        backgroundImage: `url(${bgC})`,
    }}
    >
    {/* ===== Top Overlay ===== */}
    <div className="absolute inset-0 bg-black/35" />

    {/* ===== HEADER ===== */}
    <div className="relative z-10 flex items-center justify-between px-4 py-3 bg-[#162766]">
    <img src={logo} alt="Connect with Attorney" className="h-7" />

    {/* Hamburger */}
    <button
        onClick={() => setShowCallPopup((prev) => !prev)}
        className="flex flex-col gap-[5px]"
    >
        <span className="w-6 h-[2px] bg-white rounded" />
        <span className="w-6 h-[2px] bg-white rounded" />
        <span className="w-6 h-[2px] bg-white rounded" />
    </button>
    </div>


    {/* ===== CALL SLIDE DROPDOWN ===== */}
    <div
        className={`
        absolute top-[56px] right-4
        bg-[#162766]
        text-white
        text-[14px]
        px-5 py-3
        rounded-lg
        shadow-xl
        transition-all duration-300 ease-out
        ${
            showCallPopup
            ? "opacity-100 translate-y-0"
            : "opacity-0 -translate-y-2 pointer-events-none"
        }
        `}
    >
        <a href="tel:18882021350" className="font-semibold">
        (888) 202 1350
        </a>
    </div>

    {/* ===== HERO CONTENT ===== */}
    <div className="relative z-10 px-4 pt-12 pb-14 text-white">
        <h1 className="text-[24px] leading-[30px] font-semibold mb-4">
        Sexually Assaulted in an <br /> Uber or Lyft?
        <span className="font-bold"> Get a Free <br />
        Case Review
        </span>
        </h1>

        <p className="text-[14px] leading-[22px] text-white/90 max-w-[420px]">
        Uber/Lyft assault claims often depend on proof of the ride and the type of contact involved. Start with a private screening to see if you meet the requirements.   
        </p>
    </div>
    </div>


      {/* ===== MOBILE FORM ===== */}
      <div className="md:hidden bg-white px-4  pb-10">
        <div className="bg-white rounded-[16px] shadow-xl overflow-hidden px-4 py-6">

          <h2 className="font-poppins text-[18px] font-bold text-[#162766] mb-4">
            Get Your Free Case Review Today
          </h2>

          <form onSubmit={handleMobileSubmit} className="space-y-4">
            <input type="hidden" id="xxTrustedFormCertUrl_mobile" name="xxTrustedFormCertUrl" />
            <input type="hidden" id="xxTrustedFormCertToken_mobile" name="xxTrustedFormCertToken" />
            <input type="hidden" id="xxTrustedFormPingUrl_mobile" name="xxTrustedFormPingUrl" />
            <div>
              <label className="text-[13px] font-medium text-[#162766]">Full name</label>
              <input
                value={mobileFormData.fullName}
                onChange={(e) => setMobileFormData({ ...mobileFormData, fullName: e.target.value })}
                className={`mt-1 w-full border rounded-md px-3 py-2 text-[14px] ${
                  mobileTouched.fullName && mobileErrors.fullName
                    ? "border-red-500 focus:border-red-500"
                    : "border-[#D7DBEA]"
                }`}
                placeholder="John Smith"
              />
              {mobileTouched.fullName && mobileErrors.fullName && (
                <span className="text-[11px] text-red-500">{mobileErrors.fullName}</span>
              )}
            </div>

            <div>
              <label className="text-[13px] font-medium text-[#162766]">Phone Number</label>
              <input
                value={mobileFormData.phone}
                onChange={(e) => {
                  const input = e.target.value.replace(/\D/g, '');
                  let formatted = '';

                  if (input.length > 0) {
                    formatted = '(' + input.substring(0, 3);
                    if (input.length > 3) {
                      formatted += ') ' + input.substring(3, 6);
                    }
                    if (input.length > 6) {
                      formatted += '-' + input.substring(6, 10);
                    }
                  }

                  setMobileFormData({ ...mobileFormData, phone: formatted });
                }}
                maxLength={14}
                className={`mt-1 w-full border rounded-md px-3 py-2 text-[14px] ${
                  mobileTouched.phone && mobileErrors.phone
                    ? "border-red-500 focus:border-red-500"
                    : "border-[#D7DBEA]"
                }`}
                placeholder="(888) 333-4455"
              />
              {mobileTouched.phone && mobileErrors.phone && (
                <span className="text-[11px] text-red-500">{mobileErrors.phone}</span>
              )}
            </div>

            <div>
              <label className="text-[13px] font-medium text-[#162766]">Email</label>
              <input
                type="email"
                value={mobileFormData.email}
                onChange={(e) => setMobileFormData({ ...mobileFormData, email: e.target.value })}
                className={`mt-1 w-full border rounded-md px-3 py-2 text-[14px] ${
                  mobileTouched.email && mobileErrors.email
                    ? "border-red-500 focus:border-red-500"
                    : "border-[#D7DBEA]"
                }`}
                placeholder="e.g. john.smith@mail.com"
              />
              {mobileTouched.email && mobileErrors.email && (
                <span className="text-[11px] text-red-500">{mobileErrors.email}</span>
              )}
            </div>

            {/* Q1 - Radio  */}
            <div>
              <p className="text-[13px] font-semibold text-[#162766] mb-2">
                Q1. Was the offender your Uber/Lyft driver during a ride?
              </p>
              <div className="flex gap-3">
                {["Yes", "No"].map((opt) => (
                  <label
                    key={opt}
                    className="flex-1 flex items-center gap-2 px-3 py-2 border rounded-md border-[#D7DBEA] cursor-pointer has-[:checked]:bg-[#E1E4F0]"
                  >
                    <input
                      type="radio"
                      name="mq1"
                      value={opt}
                      checked={mobileFormData.q1 === opt}
                      onChange={(e) => {
                        setMobileFormData({ ...mobileFormData, q1: e.target.value });
                      }}
                      className="peer hidden"
                    />

                    <span
                      className="
                        w-4 h-4
                        rounded-full
                        border border-[#162766]
                        flex items-center justify-center
                        peer-checked:border-[#162766]
                        peer-checked:bg-[#162766]
                        [&>svg]:hidden
                        peer-checked:[&>svg]:block
                      "
                    >
                      <svg
                        width="10"
                        height="8"
                        viewBox="0 0 9 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.07764 0.551758C8.14631 0.48331 8.25808 0.483174 8.32666 0.551758C8.39519 0.620347 8.39509 0.732131 8.32666 0.800781L3.44775 5.67773C3.37274 5.75272 3.27061 5.79492 3.16455 5.79492C3.05859 5.79491 2.95731 5.7526 2.88232 5.67773L0.550293 3.3457C0.482781 3.27815 0.483011 3.16828 0.550293 3.10059C0.617975 3.0329 0.72774 3.0329 0.79541 3.10059L2.80811 5.11426L3.16162 5.46777L8.07764 0.551758Z"
                          fill="#F8D216"
                          stroke="#F8D216"
                          strokeWidth="0.5"
                        />
                      </svg>
                    </span>

                    <span className="text-[13px]">{opt}</span>
                  </label>
                ))}
              </div>
              {mobileTouched.q1 && mobileErrors.q1 && (
                <span className="text-[11px] text-red-500">{mobileErrors.q1}</span>
              )}
            </div>

            {/* Q2 - Dropdown (was previously Q1, markup untouched) */}
            <div>
              <label className="text-[13px] font-semibold text-[#162766] mb-2 block">
                Q2. What best describes what happened?
              </label>
              <select
                value={mobileFormData.q2}
                onChange={(e) =>
                  setMobileFormData({ ...mobileFormData, q2: e.target.value })
                }
                className={`w-full border rounded-md px-3 py-2.5 text-[13px] ${
                  mobileTouched.q2 && mobileErrors.q2
                    ? "border-red-500 focus:border-red-500"
                    : "border-[#D7DBEA]"
                }`}
              >
                <option value="">Please select an option</option>
                <option value="Forced sexual act (forced oral, forced manual stimulation)">Forced sexual act (forced oral, forced manual stimulation)</option>
                <option value="Non-consensual sexual touching or kissing of a sexual body part">Non-consensual sexual touching or kissing of a sexual body part</option>
                <option value="Indecent exposure / masturbation">Indecent exposure / masturbation</option>
                <option value="Kidnapping / false imprisonment with overt sexual or extreme physical threats">Kidnapping / false imprisonment with overt sexual or extreme physical threats</option>
                <option value="Other">Other</option>
                <option value="None of the above">None of the above</option>
              </select>
              {mobileTouched.q2 && mobileErrors.q2 && (
                <span className="text-[11px] text-red-500">{mobileErrors.q2}</span>
              )}
            </div>

            {/* Q3 - unchanged */}
            <div>
              <p className="text-[13px] font-semibold text-[#162766] mb-2">
                Q3. Are you currently working with an attorney or have you already filed a rideshare claim for this incident?
              </p>
              <div className="flex gap-3">
                {["Yes", "No"].map((opt) => (
                  <label
                    key={opt}
                    className="flex-1 flex items-center gap-2 px-3 py-2 border rounded-md border-[#D7DBEA] cursor-pointer has-[:checked]:bg-[#E1E4F0]"
                  >
                    <input
                      type="radio"
                      name="mq3"
                      value={opt}
                      checked={mobileFormData.q3 === opt}
                      onChange={(e) => {
                        setMobileFormData({ ...mobileFormData, q3: e.target.value });
                      }}
                      className="peer hidden"
                    />

                    <span
                      className="
                        w-4 h-4
                        rounded-full
                        border border-[#162766]
                        flex items-center justify-center
                        peer-checked:border-[#162766]
                        peer-checked:bg-[#162766]
                        [&>svg]:hidden
                        peer-checked:[&>svg]:block
                      "
                    >
                      <svg
                        width="10"
                        height="8"
                        viewBox="0 0 9 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.07764 0.551758C8.14631 0.48331 8.25808 0.483174 8.32666 0.551758C8.39519 0.620347 8.39509 0.732131 8.32666 0.800781L3.44775 5.67773C3.37274 5.75272 3.27061 5.79492 3.16455 5.79492C3.05859 5.79491 2.95731 5.7526 2.88232 5.67773L0.550293 3.3457C0.482781 3.27815 0.483011 3.16828 0.550293 3.10059C0.617975 3.0329 0.72774 3.0329 0.79541 3.10059L2.80811 5.11426L3.16162 5.46777L8.07764 0.551758Z"
                          fill="#F8D216"
                          stroke="#F8D216"
                          strokeWidth="0.5"
                        />
                      </svg>
                    </span>

                    <span className="text-[13px]">{opt}</span>
                  </label>
                ))}
              </div>
              {mobileTouched.q3 && mobileErrors.q3 && (
                <span className="text-[11px] text-red-500">{mobileErrors.q3}</span>
              )}
            </div>

            <div>
              <label className="flex items-start gap-2 text-[11px] text-[#5A627A] leading-snug">
                <input
                  type="checkbox"
                  checked={mobileFormData.consent}
                  onChange={(e) => {
                    setMobileFormData({ ...mobileFormData, consent: e.target.checked });
                  }}
                  className="mt-0.5 accent-[#162766]"
                />
                <span>
                  I agree to the <a href="/PrivacyPolicy" target="_blank" rel="noopener noreferrer" className="hover:text-blue-800 font-bold">Privacy Policy</a>{' '}
                  and <a href="/Disclaimer" target="_blank" rel="noopener noreferrer" className="hover:text-blue-800 font-bold">Disclaimer</a> and give my express written consent,
                  affiliates and/or lawyer to contact you at the number provided above, even if this number is a wireless number or if I am presently listed on a Do Not Call list. 
                  I understand that I may be contacted by telephone, email, text message or mail regarding case options and that I may be called using automatic dialing equipment. 
                  Message and data rates may apply. My consent does not require purchase. This is Legal advertising.
                </span>
              </label>
              {mobileTouched.consent && mobileErrors.consent && (
                <span className="text-[11px] text-red-500 block mt-1">
                  {mobileErrors.consent}
                </span>
              )}
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full bg-[#F8D216] text-[#162766] font-bold tracking-widest py-3 rounded-lg hover:bg-[#E5C414] transition-colors flex items-center justify-center gap-2 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
              {isSubmitting ? (
                <>
                  <div className="w-5 h-5 border-2 border-[#162766] border-t-transparent rounded-full animate-spin"></div>
                  <span>SUBMITTING...</span>
                </>
              ) : (
                'REVIEW MY CASE'
              )}
            </button>
          </form>
        </div>
      </div>

      {/* ================= MOBILE UNDERSTANDING ================= */}
      <section className="md:hidden w-full bg-[#EBEEFF] pt-10 overflow-hidden relative">

            {/* ===== TEXT CONTENT ===== */}
            <div className="px-5 text-[#1B2B6B]">
                <h2 className="text-[24px] leading-[32px] font-semibold mb-4">
                Your safety was violated. <br /> <span className="font-bold">You deserve support</span> and a <br />
                <span className="font-bold">path forward.</span>
                </h2>

                <p className="text-[18px] font-lato leading-[22px] text-[#162766] mb-4">
                A rideshare is supposed to be a safe way home, not a situation where you’re trapped, threatened, or touched without consent. If you were sexually assaulted by an Uber or Lyft driver, you may be eligible to pursue compensation, especially when the assault involved physical contact, happened in or around the vehicle, and you can provide (or obtain) your ride receipt.   
                </p>

                <p className="text-[16px] font-lato leading-[22px] text-[#162766] mb-6">
                What happened is not your fault. A case review can help you understand what qualifies and what steps protect your rights. 
                </p>

                
            </div>

            {/* ===== FULL-WIDTH IMAGE ===== */}
            <div className="relative">
                <img
                src={womanLawyerC}
                alt="Attorney consultation"
                className="w-full object-cover rounded-t-[24px]"
                />

                {/* CTA */}
                <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="
                    absolute
                    bottom-0
                    right-0
                    bg-[#1B2B6B]
                    text-white
                    text-[13px]
                    font-semibold
                    px-5
                    py-2.5
                    rounded-tl-md
                    shadow-lg
                    hover:bg-[#162766]
                    transition-colors
                "
                >
                See If You Qualify
                </button>
            </div>
      </section>



      {/* ================= MOBILE 3 CARDS ================= */}
      <section className="md:hidden w-full bg-white">

            {/* ===== YELLOW TOP LINE ===== */}
            <div className="w-full h-[6px] bg-[#F8D216]" />

            {/* ===== CARDS ===== */}
            <div className="px-4 py-10 space-y-8">

                {/* CARD 1 */}
                <div className="bg-white rounded-xl shadow-[0_6px_20px_rgba(0,0,0,0.08)] overflow-hidden">
                {/* HEADER */}
                <div className="bg-[#162766] px-5 py-8 min-h-[120px] flex items-center justify-between">
                    <h3 className="text-white text-[22px] font-roboto font-medium uppercase leading-[1.25]">
                    IT HAPPENED 
                    <br />
                    DURING THE RIDE 
                    </h3>
                    <img src={symptomsarentsmall} alt="" className="w-11 h-11" />
                </div>

                {/* BODY */}
                <div className="px-5 py-7 font-roboto text-[16px] font-lato leading-[1.65] font-medium text-[#162766]/80">
                    If the assault occurred in the car, just outside it, or as part of the ride situation, it may qualify, even if it continued after the drop-off.
                </div>
                </div>

                {/* CARD 2 */}
                <div className="bg-white rounded-xl shadow-[0_6px_20px_rgba(0,0,0,0.08)] overflow-hidden">
                <div className="bg-[#162766] px-5 py-8 min-h-[120px] flex items-center justify-between">
                    <h3 className="text-white text-[22px] font-roboto font-medium uppercase leading-[1.25]">
                    TREATMENT GETS
                    <br />
                    EXPENSIVE FAST
                    </h3>
                    <img src={dollarbag} alt="" className="w-11 h-11" />
                </div>

                <div className="px-5 py-7 text-[16px] font-roboto leading-[1.65] font-medium text-[#162766]/90">
                After an assault, costs can include ER visits, counseling, medication, missed work, and long-term care. Compensation may help relieve that burden.
                </div>
                </div>

                {/* CARD 3 */}
                <div className="bg-white rounded-xl shadow-[0_6px_20px_rgba(0,0,0,0.08)] overflow-hidden">
                <div className="bg-[#1B2B6B] px-5 py-8 min-h-[120px] flex items-center justify-between">
                    <h3 className="text-white text-[22px] font-roboto font-medium uppercase leading-[1.25]">
                    QUALIFYING RULES
                    <br />
                    ARE STRICT
                    </h3>
                    <img src={symptomsarentsmall} alt="" className="w-11 h-11" />
                </div>

                <div className="px-5 py-7 text-[16px] font-roboto leading-[1.65] font-medium text-[#162766]/80">
                    Filing windows vary by state. A quick review can confirm whether your case may still be within the statute of limitations.
                </div>
                </div>

            </div>
      </section>


      {/* ================= MOBILE CHART ================= */}
      <section className="md:hidden relative w-full bg-white px-4 pt-10 pb-20 overflow-hidden">

            {/* ===== IMAGE ===== */}
            <div className="flex justify-center mb-6">
                <img
                src={statistics}
                alt="Depo-Provera statistics"
                className="w-[310px] h-auto"
                />
            </div>

            {/* ===== HEADING (CENTERED) ===== */}
            <h2 className="text-[24px] leading-[26px] font-roboto font-bold text-[#162766] mx-4 mb-6 text-center">
                What Typically Matters in Rideshare Assault Claims?  
            </h2>

            {/* ===== BULLETS (CENTERED BLOCK) ===== */}
            <div className="flex justify-center">
                <ul className="space-y-4 text-[16px] font-lato leading-[1.7] text-[#162766] list-disc pl-5 max-w-[520px]">
                    <li>
                        The offender was an Uber or Lyft driver (not another passenger).  
                    </li>
                    <li>
                        The incident involved physical sexual contact (not only messages or verbal harassment).  
                    </li>
                    <li>
                        You can provide the ride receipt or confirm you can obtain it. 
                    </li>
                    <li>
                        You told someone Uber/Lyft, police, a medical provider, a therapist, or a trusted person, near the time it happened.  
                    </li>
                    </ul>
            </div>

            {/* ===== CTA ===== */}
            <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="
                absolute
                bottom-0
                right-0
                bg-[#1B2B6B]
                text-white
                text-[13px]
                font-semibold
                px-5
                py-3
                rounded-tl-md
                hover:bg-[#162766]
                transition-colors
                "
            >
                See If You Qualify
            </button>

      </section>



      {/* ================= MOBILE ELABORATION ================= */}
      <section className="md:hidden relative w-full bg-[#EBEEFF] overflow-hidden">

            {/* ===== TOP YELLOW LINE ===== */}
            <div className="w-full h-[8px] bg-[#F8D216]" />

            {/* ===== TEXT CONTENT ===== */}
            <div className="px-5 pt-8 pb-6 text-[#162766]">
                <h2 className="text-[30px] font-lato leading-tight font-normal mb-6">
                You don't have to carry this alone. We help you 
                <span className="font-semibold"> take the next step.</span>
                
                </h2>

                <p className="text-[18px] font-lato leading-[22px] font-medium mb-8">
                After a rideshare assault, survivors often feel overwhelmed, unsure what counts, who will believe them, and what proof matters. Our job is to make the first step simple, respectful, and private.   
                </p>

                <p className="text-[16px] font-lato leading-[22px] mb-6">
                <span className="font-semibold">CONFIDENTIAL CASE REVIEW</span>{" "}
                Share what happened in a secure screening. We focus on the facts that drive eligibility, ride receipt, location/timing, and type of contact. 
                </p>

                <p className="text-[16px] font-lato leading-[22px] mb-6">
                <span className="font-semibold">TRAUMA-INFORMED SUPPORT</span>{" "}
                You control the pace. We can connect you with attorneys who handle these cases with sensitivity, not pressure.
                </p>

                <p className="text-[16px] font-lato leading-[22px] mb-6">
                <span className="font-semibold">DOCUMENTATION SUPPORT</span>{" "}
                If you don’t have the ride receipt or records yet, we’ll tell you what to request and what details to gather so your case review is stronger. 
                </p>

                <p className="text-[16px] font-lato leading-[22px] mb-6">
                <span className="font-semibold">NO UPFRONT COST</span>{" "}
                Many attorneys work on contingency, meaning you typically pay nothing unless compensation is recovered. 
                </p>
            </div>

            {/* ===== IMAGE (FULL WIDTH) ===== */}
            <div className="relative w-full">
                <img
                src={rideC}
                alt="Rideshare sexual assault"
                className="w-full object-cover"
                />

                {/* ===== CTA OVER IMAGE ===== */}
                <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="
                    absolute
                    bottom-0
                    right-0
                    bg-[#1B2B6B]
                    text-white
                    text-[13px]
                    font-semibold
                    px-5
                    py-3
                    rounded-tl-md
                    hover:bg-[#162766]
                    transition-colors
                "
                >
                See If You Qualify
                </button>
            </div>

            {/* ===== BOTTOM YELLOW LINE ===== */}
            <div className="w-full h-[6px] bg-[#F8D216]" />

      </section>

      {/*===== MOBILE BLUE BG TEXT SECTION ====== */}
      <section className="md:hidden w-full bg-[#162766] px-5 py-14 text-center">

            {/* ===== HEADING ===== */}
            <h2 className="text-[28px] font-lato leading-[32px] font-semibold text-white mb-4">
                Confidential Case Reviews
            </h2>

            {/* ===== DIVIDER LINE ===== */}
            <div className="w-[240px] h-[4px] bg-white/40 mx-auto mb-5" />

            {/* ===== SHORT BLURB ===== */}
            <p className="text-[18px] font-lato leading-[24px] text-white mb-10">
                for Uber & Lyft Assault Claims  
            </p>

            {/* ===== MAIN PARAGRAPH ===== */}
            <p className="text-[18px] font-lato leading-[28px] text-white max-w-[320px] mx-auto">
                ConnectwithAttorney helps screen rideshare sexual assault cases and connect eligible survivors with attorneys. Eligibility often depends on driver involvement, physical contact, receipt verification, reporting, and state deadlines. If your incident matches the criteria, you may be able to pursue compensation.  
            </p>

      </section>

      {/* ===== MOBILE FAQ SECTION ===== */}
      <section className="md:hidden relative w-full bg-white px-5 pt-10 pb-20 overflow-hidden">

            {/* ===== HEADING ===== */}
            <h2 className="text-[30px] font-lato leading-tight font-normal text-[#162766] mb-4">
                <span className="font-semibold">We’ll help you <span className="font-normal">understand what qualifies,</span>  step by step.</span>
            </h2>

            {/* ===== INTRO PARAGRAPH ===== */}
            <p className="text-[16px] font-lato font-normal leading-[22px] text-[#162766] mt-8 mb-8">
                You don’t need to understand legal language to take action. Our screening is designed to match the actual criteria that law firms require, so you don’t waste time.  
            </p>

            

            {/* ===== FAQ ===== */}
            <div className="border border-[#E2E6F3] rounded-lg overflow-hidden ">

                {/* No Win, No Fee */}
                <button
                onClick={() => toggleFaq("fee")}
                className={`w-full px-4 py-3 flex font-lato justify-between items-center text-left text-[16px] font-semibold
                    ${faqOpen.fee ? "bg-[#162766] text-white" : "bg-[#EBEEFF] text-[#162766]"}`}
                >
                No Win, No Fees
                <span className={`transition-transform ${faqOpen.fee ? "rotate-180" : ""}`}>
                    ▾
                </span>
                </button>

                <div
                className={`overflow-hidden transition-all duration-300 ${
                    faqOpen.fee ? "max-h-[200px]" : "max-h-0"
                }`}
                >
                <div className="px-4 py-3 text-[16px] font-lato leading-[21px] text-[#162766] bg-white">
                    Many claims are handled on contingency—no upfront fees in most cases.
                </div>
                </div>

                {/* Medical Record Review */}
                <button
                onClick={() => toggleFaq("records")}
                className="w-full px-4 py-3 flex justify-between font-lato items-center text-left text-[16px] font-medium bg-[#EBEEFF] text-[#162766] border-t border-[#E2E6F3]"
                >
                Evidence That Matters
                <span className={`transition-transform ${faqOpen.records ? "rotate-180" : ""}`}>
                    ▾
                </span>
                </button>

                <div
                className={`overflow-hidden transition-all duration-300 ${
                    faqOpen.records ? "max-h-[200px]" : "max-h-0"
                }`}
                >
                <div className="px-4 py-3 text-[16px] font-lato leading-[21px] text-[#162766] bg-white">
                    Ride receipt, timeline, reporting, and any medical/therapy records can strengthen a claim.
                </div>
                </div>

                {/* Personal Support */}
                <button
                onClick={() => toggleFaq("support")}
                className="w-full px-4 py-3 flex justify-between font-lato items-center text-left text-[16px] font-medium bg-[#EBEEFF] text-[#162766] border-t border-[#E2E6F3]"
                >
                Protect Your Deadline
                <span className={`transition-transform ${faqOpen.support ? "rotate-180" : ""}`}>
                    ▾
                </span>
                </button>

                <div
                className={`overflow-hidden transition-all duration-300 ${
                    faqOpen.support ? "max-h-[200px]" : "max-h-0"
                }`}
                >
                <div className="px-4 py-3 text-[16px] font-lato leading-[21px] text-[#3E4A6B] bg-white">
                    State time limits vary. A review helps confirm whether you may still be eligible.
                </div>
                </div>

            </div>
            {/* ===== SUPPORT INFO BLOCK (ATTACHED TO FAQ) ===== */}
            <div className="bg-[#EBEEFF] px-4 py-6 mb-6 rounded-b-lg text-[#162766]">

            <h3 className="text-[20px] font-lato leading-[26px] font-semibold mb-5">
               Why survivors choose ConnectwithAttorney? 
            </h3>

            <p className="text-[16px] font-lato leading-[1.65] text-[#162766] mb-6">
                 If you’ve been diagnosed with a meningioma after Depo-Provera use, you deserve to know your options. 
            </p>


            <ul className="space-y-4 text-[16px] font-lato leading-[1.7] text-[#162766] list-disc pl-5 max-w-[520px] mb-6">
                    <li>
                        Assault by an Uber/Lyft driver  
                    </li>
                    <li>
                        Physical contact (including qualifying tiers)   
                    </li>
                    <li>
                        Receipt confirmation   
                    </li>
                    <li>
                        Reporting pathway (rideshare company, police, medical, therapist, or trusted person)  
                    </li>
                    <li>
                        Deadline checks based on your state  
                    </li>
            </ul>

            </div>


            {/* ===== CTA ===== */}
            <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="
                absolute
                bottom-0
                right-0
                bg-[#1B2B6B]
                text-white
                text-[13px]
                font-semibold
                px-5
                py-3
                rounded-tl-md
                hover:bg-[#162766]
                transition-colors
                "
            >
                See If You Qualify
            </button>

      </section>

      {/* ================= MOBILE FOOTER CTA ================= */}
      <section className="md:hidden relative w-full bg-[#162B6F] py-10">

            {/* ===== TOP YELLOW LINE ===== */}
            <div className="absolute top-0 left-0 w-full h-[8px] bg-[#F8D216]" />

            <div className="px-5 text-center">
                <h2 className="text-[24px] font-lato leading-[28px] font-medium text-white mb-3">
                Ready To Get a Free <br />
                 Rideshare Sexual Assault <br /> Lawsuit Review?
                </h2>

                <div className="w-[32px] h-[2px] bg-[#F8D216] mx-auto mb-4" />

                <p className="text-[16px] font-lato leading-[22px] text-white/90 mb-7">
                Contact our legal partners today.
                </p>

                <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="
                    w-full
                    h-[46px]
                    bg-[#F9D51C]
                    text-[#0E1E4D]
                    text-[14px]
                    font-extrabold
                    tracking-widest
                    rounded-[8px]
                "
                >
                GET HELP NOW
                </button>
            </div>
      </section>

    </div>
  );
};

export default RideshareSexualAssaultLawsuitC;